var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket_frame"},[_c('button',{staticClass:"button ml-3",attrs:{"type":"button"},on:{"click":_vm.openTicket}},[_c('i',{staticClass:"fa fa-external-link fa-ninja fa-ninja-white"}),_vm._v(" Open Ticket")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed229ae8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/inputs/HubSpotTicket.vue
// module id = null
// module chunks = 